import type { CartItemResponse } from '../../model/cart/cart';

/**
 * The bag line price: the per-unit price being charged, plus the per-unit regular price to show
 * struck through when the item is discounted — the same `sale < original` rule the PDP uses.
 */
export function getCartItemDisplayPrice(item: Pick<CartItemResponse, 'price'>) {
  const { price, regularPrice } = item.price;
  const isDiscounted = price < regularPrice;
  return { price, originalPrice: isDiscounted ? regularPrice : null };
}
